
import Vue from 'vue'
import { DataSet } from '@/services/DataSet'

export default Vue.extend({
   name: 'PagerDisplay',
   props: {
      data: Object as () => DataSet,
   },
   computed: {
      displayPhrase(): string {
         if (this.data.totalItemCount === 0) {
            return this.$tc('result', 0)
         } else if (this.data.totalItemCount === 1) {
            return this.$tc('result', 1)
         } else if (this.data.itemCount === this.data.totalItemCount) {
            return this.$tc('result', this.data.totalItemCount)
         } else {
            return (
               `${this.data.firstItemNumber}-${this.data.lastItemNumber} ` +
               this.$tc('of result', this.data.totalItemCount)
            )
         }
      },
   },
})
